/** Throttle reloads so a broken deploy or offline state cannot spin forever. */
const RELOAD_TS_KEY = 'crossroad:chunk-reload-ts'
const RELOAD_WINDOW_MS = 12_000

function errorMessage(reason: unknown): string {
  if (reason instanceof Error) {
    return reason.message
  }
  if (typeof reason === 'string') {
    return reason
  }
  return ''
}

/**
 * Detects failed lazy route chunks after a new deployment (stale index / tab).
 */
export function isChunkLoadFailure(reason: unknown): boolean {
  const message = errorMessage(reason)
  return (
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('Importing a module script failed') ||
    message.includes('error loading dynamically imported module') ||
    /Loading chunk \d+ failed/i.test(message)
  )
}

/**
 * Full reload once per time window so the browser fetches fresh index.html and chunk URLs.
 */
export function reloadOnceForStaleChunk(): void {
  if (typeof window === 'undefined') {
    return
  }
  try {
    const last = Number(sessionStorage.getItem(RELOAD_TS_KEY) || '0')
    const now = Date.now()
    if (now - last < RELOAD_WINDOW_MS) {
      return
    }
    sessionStorage.setItem(RELOAD_TS_KEY, String(now))
  } catch {
    // sessionStorage unavailable (e.g. private mode restrictions) — still try reload
  }
  window.location.reload()
}
